var $4982a1454ba1cfa0$exports = {};
$4982a1454ba1cfa0$exports = {
    "clear": `Izbri\u{161}i`,
    "invalid": `(neva\u{17E}e\u{107}e)`,
    "loading": `U\u{10D}itavam...`,
    "noResults": `Nema rezultata`,
    "valid": `(va\u{17E}e\u{107}e)`
};


export {$4982a1454ba1cfa0$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
